module.exports = __webpack_public_path__ + "static/img/2.33dd7e53.png";